<template>
  <v-app>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </v-app>
</template>

<script>
// Autologout article:  https://css-tricks.com/detecting-inactive-users/

  window.zESettings = {
    webWidget: {
      color: {
        theme: '#FF69B4',
        launcher: '#CC3A83', // This will also update the badge
        launcherText: '#E589B7',
        button: '#8A0648',
        resultLists: '#691840',
        header: '#203D9D',
        articleLinks: '#FF4500'
      }
    }
  }

export default {
  created() {
    
  },
}
</script>

<style>
    .v-main{
      padding-top:32px !important;
      margin-left:5% !important;
      margin-right: 5% !important;
      
    }
  .container {
    padding-top: -30px !important;
  }

  /* Transitions ---------------------------------------------------------- */
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease-out;
  }

  .fade-leave-to {
    opacity: 0;
  }

  .slide-fade-enter {
    transform: translateY(50px);
    opacity: 0;
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.8s ease-out;
  }

  .slide-fade-leave-to {
    opacity: 0;
  }
  .description{
    padding: 15px;
    padding-top: 5px;
    margin-bottom: 0px!important;
  }
  .description{
    padding: 15px;
    padding-top: 10px;
}
.errorMessage{
    background: white;
    color: red;
    padding: 10px;
}
.errorBorder{
    border: 1px solid red;
}
.hidden{
    display: none;
}
    /* All table rows */
  /* tbody tr:nth-of-type(odd) {
   background-color: rgba(242, 102, 66, .03);
  } */


/* Mobile L and < */
/* @media only screen and (max-width: 425px) {
  tbody tr:nth-of-type(odd) td {
   background-color: rgba(242, 102, 66, .05);
  }
} */

</style>
